import { useState } from "react";
import { Box, IconButton, Popover } from "@mui/material";
import SettingsIcon from "@mui/icons-material/Settings";
import StrategyTaxStateSetting from "../StrategyTaxStateSetting";
import StrategyFederalTaxSetting from "../StrategyFederalTaxSetting";

/**
 * The gear beside the Keep card's Tax Savings label, opening the state and
 * federal tax rates. Both rates are sent with Calculate, where they drive
 * that card's tax savings.
 */
const KeepTaxSettings = () => {
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);
  return (
    <>
      <IconButton
        size="small"
        aria-label="Tax savings settings"
        sx={{ p: 0.25, fontSize: 16 }}
        onClick={(event) => setAnchor(event.currentTarget)}
      >
        <SettingsIcon fontSize="inherit" />
      </IconButton>
      <Popover
        open={Boolean(anchor)}
        anchorEl={anchor}
        onClose={() => setAnchor(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Box sx={{ p: 2, width: 320 }}>
          <StrategyTaxStateSetting />
          <StrategyFederalTaxSetting />
        </Box>
      </Popover>
    </>
  );
};

export default KeepTaxSettings;
